import Cookies from 'universal-cookie';
import config from './../config';

const cookies = new Cookies();

cookies.utils = {
    setLang(language) {
        const cookie = config.cookies.language;

        cookies.set(cookie, language, { maxAge: 315569520000 });
    },
};

export default cookies;
